import { render, staticRenderFns } from "./InputBox.vue?vue&type=template&id=3609067e&scoped=true&"
import script from "./InputBox.vue?vue&type=script&lang=js&"
export * from "./InputBox.vue?vue&type=script&lang=js&"
import style0 from "./InputBox.vue?vue&type=style&index=0&id=3609067e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3609067e",
  null
  
)

export default component.exports